<div class="main-component p-0">
  <div class="header-content">
    <div class="header-left">
      <img class="main-logo" height="30px" src="assets/images/Logo_proeconomy-transparent.svg" alt="Pro Economy">
      <div class="flex-center-content">
        @if (!!app.user) {
          <h2 class="user-name">{{ app.userDisplayName }}</h2>
        }
      </div>
    </div>
    <div class="flex-center-content">
      <mat-icon class="menu-icon"
        [matMenuTriggerFor]="settingsMenu"
        matTooltip="Account Settings"
        aria-hidden="false"
      aria-label="Account Settings">account_circle</mat-icon>
      <mat-menu #settingsMenu="matMenu" xPosition="before">
        @if (app.user) {
          <div class="menu-user-name">{{ app.userDisplayName }}</div>
          <div class="menu-user-email">{{ app.user }}</div>
        } @else {
          <div class="menu-user-name">Not logged in</div>
        }
        <hr class="menu-divider">
        @if (app.user) {
          <button type="button" mat-menu-item (click)="passwordChange()">Change Password</button>
        }
        @if (app.user) {
          <button type="button" mat-menu-item (click)="logout()">Logout</button>
        }
        <hr class="menu-divider">
        <div class="menu-version">Tetras v{{app.version}} &nbsp;·&nbsp; Built {{app.buildTime}}</div>
      </mat-menu>
    </div>
  </div>

  <div class="main-content-wrapper">
    <div class="center-content">
      @if (fieldRole || adminRole) {
        <button mat-raised-button (click)="navigateToField()" type="button" color="primary" class="large-services-btn">
          <img src="assets/images/tetras field.svg" alt="Tetras Field" class="service-btn-img"><br>
          <span class="title-separator">•</span><br>
          <span class="subtitle">Operations & Tasks</span>
        </button>
      }
      @if (cloudRole || adminRole) {
        <button mat-raised-button (click)="navigateToCloud()" type="button" color="primary" class="large-services-btn">
          <img src="assets/images/tetras cloud.svg" alt="Tetras Cloud" class="service-btn-img"><br>
          <span class="title-separator">•</span><br>
          <span class="subtitle">Results, Reports & Compliance</span>
        </button>
      }
    </div>
  </div>
</div>
